import "@/main.components";
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router/index.js";
import store from "@/store/index.js";
import plugins from "@/plugins";
import VueI18n from "vue-i18n";
import i18n from "@/plugins/i18n.js";
import "@/assets/css/common.scss";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);

const context = {
  router,
  store,
};

function inject(name, value) {
  const prop = "$" + name.replace(/^\$+/g, "");
  Vue.prototype[prop] = Vue.observable(value);
  context[prop] = Vue.prototype[prop];
}
for (const plugin of plugins) {
  Vue.use({
    install(/* Vue, options */) {
      plugin(context, inject);
    },
  });
}

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
